import { NoParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/promo-logs'

interface Endpoints {
  getAll: NoParamEndpointConstructor
  getLink: NoParamEndpointConstructor
  download: NoParamEndpointConstructor
}

export const promoLogsEndpoints: Endpoints = {
  getAll: () => baseUrl,
  getLink: () => `${baseUrl}/link`,
  download: () => `${baseUrl}/download`,
}
